import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';

interface Props {
    frais: ReqType.Frais;
    event?: ReqType.Event;
}

interface State {
}
/**
 * Ce composant permet l'affichage d'une liste de frais
 */
export class LigneFrais extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <tr key={this.props.frais.id}>
                <td scope="row" />
                <td scope="row">{this.props.event === undefined ? '' : this.props.event.intitule}</td>
                <td scope="row">
                    {this.props.event === undefined ? '' : this.props.event.date_heure_debut.toLocaleString()}
                </td>
                <td scope="row">{this.props.frais.intitule}</td>
                <td scope="row">{this.props.frais.montant} </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProfilePage/internalComponents/LigneFrais.tsx